import * as React from "react";
import { useState } from "react";
import { Button, Menu, MenuItem, Stack } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { colorPalette, serviceList } from "../../utils/constants";
import { PageId } from "../../contexts/NavigationContext";
import { useParams } from "react-router-dom";

interface ServicesMenuProps {
  activePage: PageId;
  pageButtonStyle: any;
  serviceMenuItemStyle: any;
  onServiceSelect: (serviceId: string) => void;
}

const ServicesMenu: React.FC<ServicesMenuProps> = ({
  activePage,
  pageButtonStyle,
  serviceMenuItemStyle,
  onServiceSelect,
}) => {
  const [anchorElServices, setAnchorElServices] = useState<null | HTMLElement>(null);
  const { serviceId: activeServiceId } = useParams<{ serviceId?: string }>();

  const handleOpenServicesMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElServices(event.currentTarget);
  };

  const handleCloseServicesMenu = () => {
    setAnchorElServices(null);
  };

  const handleServiceClick = (serviceId: string) => {
    onServiceSelect(serviceId);
    setAnchorElServices(null);
  };

  return (
    <>
      <Button
        onMouseEnter={handleOpenServicesMenu}
        sx={[
          pageButtonStyle,
          {
            color: activePage === "services" ? colorPalette.headerBackground : "black",
          },
        ]}
      >
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <span>Our Services</span>
          <KeyboardArrowDownIcon sx={{ fontSize: "22px !important" }} />
        </Stack>
      </Button>
      <Menu
        anchorEl={anchorElServices}
        open={Boolean(anchorElServices)}
        onClose={handleCloseServicesMenu}
        MenuListProps={{
          onMouseLeave: handleCloseServicesMenu,
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{ mt: 1 }}
      >
        {serviceList.map((service) => (
          <MenuItem
            key={service.id}
            onClick={() => handleServiceClick(service.id)}
            sx={{
              ...serviceMenuItemStyle,
              backgroundColor: activeServiceId === service.id ? `${colorPalette.headerBackground}15` : "transparent",
              color: activeServiceId === service.id ? colorPalette.headerBackground : "inherit",
              fontWeight: activeServiceId === service.id ? 600 : 400,
            }}
          >
            {service.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ServicesMenu;
